{{resultText}}
<form class="form">
  <mat-form-field class="full-width">
    <mat-label>アクセスコード</mat-label>
    <input type="text" matInput [formControl]="accessCodeFormControl"
           placeholder="アクセスコードを入力してください"
          (keydown.enter)="onEnterKey($event)">
    @if (accessCodeFormControl.hasError('invalid')) {
      <mat-error>アクセスコードが間違っています。</mat-error>
    }
    @if (accessCodeFormControl.hasError('required')) {
      <mat-error>アクセスコードの入力は <strong>必須</strong> です</mat-error>
    }
  </mat-form-field>
  <button mat-flat-button type="button" color="primary" class="full-width" (click)="onSubmit()"
          [disabled]="accessCodeFormControl.invalid">
    送信
  </button>
</form>
